<app-header></app-header>
<div
  class="wrapper mt-4"
  infiniteScroll
  [infiniteScrollDistance]="1"
  [infiniteScrollThrottle]="150"
  (scrolled)="onScroll()"
  [infiniteScrollDisabled]="shimarStatus"
>
  <app-grid-simmer
    class="search-page list-simmer"
    *ngIf="shimarStatus"
  ></app-grid-simmer>
  <div *ngIf="contentData?.length > 0 && !shimarStatus">
    <section class="related-search upcoming">
      <div class="container">
        <div>
          <div class="section-head row">
            <h2 class="col-12">{{ languageData?.name }}</h2>
          </div>
          <div class="row custome-set">
            <div
              class="series-box"
              *ngFor="let data of contentData; let i = index"
            >
              <app-grid [data]="data" [gridType]="'landscape'"></app-grid>
            </div>
          </div>
        </div>
      </div>
    </section>
    <app-grid-simmer
      class="search-page list-simmer"
      *ngIf="loadMore"
    ></app-grid-simmer>
  </div>
  <div class="container" *ngIf="contentData?.length === 0 && !shimarStatus">
    <div class="record-not-available">
      <div class="text-center">
        <img src="assets/images/no-recoard-playlist.png" />
        <p class="no-recored-content text-secondary">
          {{ "RECORD_NOT_FOUND" | translate }}
        </p>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
